import EntriesPage from './EntriesPage';

export default EntriesPage;
